export const Full = 'Full';
export const View = 'View';
